import { render, staticRenderFns } from "./Section4.vue?vue&type=template&id=bd9a6140&scoped=true"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"
import style0 from "./Section4.vue?vue&type=style&index=0&id=bd9a6140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9a6140",
  null
  
)

export default component.exports